export const Spark = ({ className = "" }) => (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
        <path d="M50 0 L58 42 L100 50 L58 58 L50 100 L42 58 L0 50 L42 42 Z" fill="currentColor" />
    </svg>
);

export const Squiggle = ({ className = "" }) => (
    <svg viewBox="0 0 200 24" fill="none" className={className} aria-hidden="true">
        <path
            d="M2 12 C 14 2, 26 22, 38 12 S 62 2, 74 12 S 98 22, 110 12 S 134 2, 146 12 S 170 22, 182 12 S 196 6, 198 12"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
        />
    </svg>
);

export const ScribbleArrow = ({ className = "" }) => (
    <svg viewBox="0 0 120 60" fill="none" className={className} aria-hidden="true">
        <path
            d="M6 8 C 30 40, 70 50, 104 34 M104 34 L88 30 M104 34 L96 48"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const starPoints = (spikes = 16, outer = 50, inner = 41) =>
    Array.from({ length: spikes * 2 }, (_, i) => {
        const r = i % 2 === 0 ? outer : inner;
        const a = (Math.PI * i) / spikes - Math.PI / 2;
        return `${(50 + r * Math.cos(a)).toFixed(2)},${(50 + r * Math.sin(a)).toFixed(2)}`;
    }).join(" ");

export const Starburst = ({ className = "", lines = ["COMING", "SOON"] }) => (
    <div className={`relative ${className}`} aria-hidden="true">
        <svg viewBox="0 0 100 100" className="h-full w-full animate-spin-slow">
            <polygon points={starPoints()} fill="currentColor" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-cream">
            {lines.map((l) => (
                <span key={l} className="font-display text-[0.9em] leading-none tracking-widest">
                    {l}
                </span>
            ))}
        </div>
    </div>
);

export const PatchBadge = ({ className = "" }) => (
    <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
        <circle cx="60" cy="60" r="56" fill="currentColor" />
        <circle cx="60" cy="60" r="48" fill="none" stroke="#F4F1EA" strokeWidth="2" strokeDasharray="5 4" />
        <path d="M60 32 L64 52 L84 60 L64 68 L60 88 L56 68 L36 60 L56 52 Z" fill="#F4F1EA" />
        <text x="60" y="26" textAnchor="middle" fill="#F4F1EA" fontSize="11" fontFamily="Bebas Neue, sans-serif" letterSpacing="2">
            PCCH
        </text>
        <text x="60" y="104" textAnchor="middle" fill="#F4F1EA" fontSize="9" fontFamily="Bebas Neue, sans-serif" letterSpacing="2">
            EST. 2026
        </text>
    </svg>
);
